import { render, staticRenderFns } from "./AcademicInformation.vue?vue&type=template&id=0a6c8d55&scoped=true"
import script from "./AcademicInformation.vue?vue&type=script&lang=ts"
export * from "./AcademicInformation.vue?vue&type=script&lang=ts"
import style0 from "./AcademicInformation.vue?vue&type=style&index=0&id=0a6c8d55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6c8d55",
  null
  
)

export default component.exports